var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.module.resource.content)?_c('div',{staticClass:"marquee-container",style:({
      fontSize : `${_vm.module.resource.content.size}px`,
      color : `${_vm.module.resource.content.color}`
    })},[_c('marquee-text',{attrs:{"duration":_vm.module.resource.content.speed,"repeat":10}},[_vm._v(" "+_vm._s(_vm.module.resource.content.textPieces.join(" " + `${_vm.module.resource.content.symbole}` + " "))+" "+_vm._s(_vm.module.resource.content.symbole)+" ‌ ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }